import { z } from "zod";

const ResponseData = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().email(),
    email_verified_at: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
    channex_user_api_key: z.string().nullable(),
    username: z.string().nullable(),
    phone: z.string(),
    roles: z.array(z.object({
        id: z.number().int(),
        name: z.string(),
        property_id: z.string().nullable(),
        display_name: z.string(),
        guard_name: z.string(),
        created_at: z.string(),
        updated_at: z.string(),
        pivot: z.object({
            model_type: z.string(),
            model_id: z.string(),
            role_id: z.number().int()
        })
    })).optional()
});

const SyncUserRolesResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: ResponseData,
});

export type SyncUserRolesResponse = z.infer<typeof SyncUserRolesResponseSchema>;
export { SyncUserRolesResponseSchema };
